import React from 'react';

import classes from './CircleLoader.scss';

export const CircleLoader: React.FC = () => <div className={classes.loader} />;
